import { ROUTES } from "../../../../module/constants";
import { generalConst } from "../../../../module/globalInterface";

export const RECOVERY_POINT_MGMT_CONSOLE_ADMIN_URLS: generalConst = {
  BASE_URL: ROUTES.ADMIN_RECOVERY_POINT_MGMT,
  STEP_TWO: `${ROUTES.ADMIN_RECOVERY_POINT_MGMT}/stepTwo`,
  STEP_THREE: `${ROUTES.ADMIN_RECOVERY_POINT_MGMT}/stepThree`,
};

export const STATE_IDENTIFIER = {
  STEP_ONE: "stepOne",
  LOADER_IDENTIFIER: "loader",
  RESPONSE_STATE: "responseState",
  ALL_USERS: "allUsers",
  SELECTED_USERS: "selectedUsers",
  USERS: "users",
  CURRENT_ABILITATIONS: "currentAbilitations",

  SELECTED_OFFICE: "selectedOffice",
  IS_SELF_SELECTED: "isSelfSelected",
  SELECTED_USER: "selectedUsers",
  ADDED_ENTITLEMENTS: "addedEntitlements",
  ADDED_BR: "addedBR",
  DELETED_ENTITLEMENTS: "deletedEntitlements",
  DELETED_BR: "deletedBR",
  MODIFIED_ENTITLEMENTS: "modifiedEntitlements",
  MODIFIED_BR: "modifiedBR",
  OFFICES: "offices",
  STEP_TWO: "stepTwo",
  USER: "user",
  STEP_THREE: "stepThree",
  PREV_ENTITLEMENTS: "prevEntitlements",
  ENTITLEMENTS: "entitlements",
  DATE_ENTITLEMENTS: "dateEntitlements",
  START_END_DATE: "startEndDates",
  BUSINESS_ROLES: "businessRoles",
  TOTAL_ENTITLEMENTS: "totalEntitlements",
  STEP_FOUR: "stepFour",
  DELEGATOR: "delegator",
  COMMENT: "comment",
  IS_COMMENT_COMPULSORY: "isCommentCompulsory",
  CALL_STATE: "callState",
  ENTITLEMENTS_BR_SELECTED: "entitlementsBRSelected",
  EXISTING_SAME_DB: "existingSameDB",
  ATTACHMENTS: "attachments",
  SOD_CONFLICTS: "sodConflicts",
};

export const LIST_IDENTIFIER: string = "list";
export const LOADER_IDENTIFIER: string = "loader";
export const BUSINESS_ROLES_IDENTIFIER: string = "businessRoles";
export const ENTITLEMENTS_IDENTIFIER: string = "entitlements";
export const SHOW_TABLE_IDENTIFIER: string = "showTable";

export interface IRecoveryPointUser {
  uniqueId: string;
  code: string;
  name: string;
  surname: string;
  organizational_unit: string;
  organizational_unit_code?: string | number;
  supervisorFullName: string;
  type: string;
  identitySystemId: string;
}

export interface IRecoveryPointUserResponse {
  pageNumber: number;
  totalElements: number;
  pageTotalNumber: number;
  pageSize: number;
  users: IRecoveryPointUser[];
}

export interface IRecoveryPointUserBody extends IRecoveryPointUser {
  pageNumber: number;
  pageSize: number;
}
